export default [
  {
    path: '/pdjh',
    component: () => import('./views/select')
  },
  {
    path: '/pdjh/index',
    component: () => import('./views/index')
  }
]



// WEBPACK FOOTER //
// ./src/page/pdjh/router.js